import { ProcedureMapEnum } from '../../models/procedure-map.enum';
import { ProcedureUnitTypeRule } from '../../models/unit-type-rules-config';
import { UnitTypes } from '@modules/teeth-diagram/models/unit-type.enum';
import { allTeeth, molarTeeth } from '../teeth-sets';
import { SoftwareOptions } from '@shared/models/enums/enums';

export const rulesForFixedRestorativeGlidewellIo: ProcedureUnitTypeRule = {
	ProcedureMaps: [ProcedureMapEnum.FixedRestorativeGlidewellIo],
	TeethRules: [
		{
			Ids: allTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypes.Regular
					},
					{
						Id: UnitTypes.Crown
					},
					{
						Id: UnitTypes.ImplantBased,
						RestrictionUnitTypes: {
							SoftwareOptions: [SoftwareOptions.ImplantBasedForGlidwewell]
						}
					}
				]
			}
		},
		{
			Ids: molarTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypes.Inlay
					},
					{
						Id: UnitTypes.Onlay
					}
				]
			}
		}
	]
};
